<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderCustomers',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'customers', text: 'Customers', to: AppRoute.Customers, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
